import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { PanelContainer } from '@atlassian/panel-system';

import type { PreviewPanelProps } from './types';

const styles = cssMap({
	wrapper: {
		height: '100%',
		backgroundColor: token('elevation.surface'),
	},
});

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanel = ({ children, testId }: PreviewPanelProps): React.JSX.Element => {
	if (fg('ads-panel-system-gpp')) {
		return <PanelContainer testId={testId}>{children}</PanelContainer>;
	}

	return (
		<Stack xcss={styles.wrapper} testId={testId}>
			{children}
		</Stack>
	);
};
